var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fLogo"},[_c('h3',[_c('i',{staticClass:"icons-logoD"}),_vm._v(_vm._s(_vm.appName))]),_c('p',[_vm._v("邮箱：services@tipdm.com")]),_c('p',[_vm._v("热线：400-684-0020")]),_c('p',[_vm._v("地址：广州市黄埔区科学城凝彩路26号锦昊智谷2005房")])])}
var staticRenderFns = []

export { render, staticRenderFns }